export default class Loader {

	constructor() {
		this.progressValue = 0;
		this.divProgress = document.createElement('loader-progress');
		this.divContainer = document.createElement('loader-container');
		this.divContainer.className = 'hidden';
		this.divContainer.append(this.divProgress);
		document.body.prepend(this.divContainer);
	}

	show() {
		this.divContainer.classList.remove('hidden');
	}

	hide() {
		this.divContainer.classList.add('hidden');
	}

	start() {
		this.show();
		this.setProgress(5);
	}

	end() {
		this.setProgress(100);
		setTimeout(() => {
			this.hide();
			this.setProgress(0);
		}, 250);
	}

	setProgress(value) {
		this.divProgress.style.width = value + '%';
		this.progressValue = value;
	}

	advance(value) {
		this.setProgress(this.progressValue + value);
	}
}
